module.exports = __webpack_public_path__ + "static/talent-is-overrated-ae1149972780a73ea1c4854ab6cefe7e.jpg";